import { req } from 'react-reqq-lite';

import { toastSuccess } from 'modules/common/toast';
import {
  removeObjectToList,
  insertNewObjectToList,
  insertUpdateObjectToList,
} from 'modules/common/utils';

import * as c from './constants';
import { transformQrCode, transformPayload } from './transformers';

export const getMenuBuilderList = (params) => {
  req.get({
    key: c.GET_MENU_BUILDER_LIST,
    url: '/v1/me/pos',
    transform: ({ data, meta, included }) => {
      const x = data?.map((i) => transformQrCode(i, included));
      return {
        list: x,
        pagination: meta?.pagination,
      };
    },
    params,
  });
};

export const createMenuBuilder = (payload, callback = () => {}) => {
  req.post({
    key: c.CREATE_MENU_BUILDER,
    url: '/v1/me/pos',
    payload: transformPayload(payload),
    onSuccess: (res) => {
      const { data } = res?.response;
      req.set(c.GET_MENU_BUILDER_LIST, (state) => {
        const { list, pagination } = state[c.GET_MENU_BUILDER_LIST] || {};
        const x = insertNewObjectToList(list, data);
        return {
          list: x,
          pagination,
        };
      });

      toastSuccess('Created successfully.');
      callback();
    },
  });
};

export const updateMenuBuilder = (
  menu_builder_uuid,
  payload,
  callback = () => {}
) => {
  req.put({
    key: c.UPDATE_SELECTED_MENU_BUILDER,
    url: `/v1/me/pos/${menu_builder_uuid}`,
    payload: transformPayload(payload),
    onSuccess: (res) => {
      const { data } = res?.response;
      req.set(c.GET_MENU_BUILDER_LIST, (state) => {
        const { list, pagination } = state[c.GET_MENU_BUILDER_LIST] || {};
        const x = insertUpdateObjectToList(list, data, 'uuid');
        return {
          list: x,
          pagination,
        };
      });

      toastSuccess('Updated successfully.');
      callback();
    },
  });
};

export const removeMenuBuilder = (menu_builder_uuid, callback = () => {}) => {
  req.remove({
    key: c.REMOVE_SELECTED_MENU_BUILDER,
    url: `/v1/me/pos/${menu_builder_uuid}`,
    onSuccess: () => {
      req.set(c.GET_MENU_BUILDER_LIST, (state) => {
        const { list, pagination } = state[c.GET_MENU_BUILDER_LIST] || {};
        const x = removeObjectToList(list, menu_builder_uuid, 'uuid');
        return {
          list: x,
          pagination,
        };
      });

      toastSuccess('Remove successfully.');
      callback();
    },
  });
};
